import styled from 'styled-components';

export default styled.div`
	display: flex;
	align-items: center;
	span:not(.motif-icon) {
		padding-right: var(--spacing-medium);
	}
	.motif-icon {
		color: var(--green-400);
	}
`;
